<div class="aix-viewer__header ph-unmask" *ngrxLet="storeFacade.documentViewer$ as documentViewer">
    @for (tab of tabs;track $index) {
    <div
        class="aix-viewer__header-title br-primary__color"
        [attr.data-testing]="tab?.toLowerCase()"
        (click)="onClickTab(tab)"
        [ngClass]="{
            'br-primary__border-color': documentViewer.tab === tab,
            inactive: documentViewer.tab !== tab
        }"
    >
        {{ tab }}
    </div>
    }
</div>

<div class="aix-viewer__content" *ngrxLet="storeFacade.documentViewer$ as documentViewer">
    @for (tab of tabs;track $index) {
    <section class="-no-padding" [hidden]="documentViewer.tab !== tab">
        <aix-header-section
            [data-testing]="'tab-content-title'"
            [title]="tab === 'Order' ? 'Order #' + storeFacade.order?.orderNumber : tab"
        >
        </aix-header-section>

        @if (tab === documentViewer.tab) {
        <div class="aix-viewer__body-content">
            @if (tab === 'Order') { @if (signaturesPreview()) {
            <div class="aix-signatures-section ph-unmask" data-testing="signatures-section">
                <div
                    class="aix-signatures-section__header"
                    data-testing="signatures-header"
                    (click)="toggleSignaturesCollapsed()"
                >
                    <h5 class="aix-signatures-section__title">Preview Signatures</h5>
                    <i class="fa-solid fa-chevron-up aix-signatures-section__chevron br-primary__color"
                       [class.aix-signatures-section__chevron--collapsed]="signaturesCollapsed"></i>
                </div>
                @if (!signaturesCollapsed) {
                <div class="aix-signatures-section__body">
                    <div class="aix-signatures-section__legend">
                        <div class="aix-signatures-section__legend-item">
                            <span class="aix-signatures-section__legend-swatch aix-signatures-section__legend-swatch--solid"></span>
                            <span class="aix-signatures-section__legend-text">DocuSign</span>
                        </div>
                        <div class="aix-signatures-section__legend-item">
                            <span class="aix-signatures-section__legend-swatch aix-signatures-section__legend-swatch--striped"></span>
                            <span class="aix-signatures-section__legend-text">Wet Sign</span>
                        </div>
                    </div>
                    @for (item of availableRoles(); track item.groupKey) {
                    <div class="aix-signatures-section__role-row" [attr.data-testing]="'signature-role-row-' + item.groupKey">
                        <span class="aix-signatures-section__role-name" data-testing="signature-role-name">{{ item.displayName }}</span>
                        @if ((signaturesForRole().get(item.groupKey)?.length ?? 0) > 0) {
                        <div class="aix-signatures-section__role-nav">
                            <button
                                class="aix-signatures-section__nav-btn br-primary__color"
                                data-testing="signature-prev"
                                (click)="onPrevSignature.emit(item.groupKey)"
                                [disabled]="hiddenRoles().has(item.groupKey)"
                            >
                                <i class="fa-regular fa-chevron-left"></i>
                            </button>
                            <span class="aix-signatures-section__nav-counter" data-testing="signature-counter">{{ getRoleFieldIndex(item.groupKey) + 1 }}/{{ signaturesForRole().get(item.groupKey)?.length ?? 0 }}</span>
                            <button
                                class="aix-signatures-section__nav-btn br-primary__color"
                                data-testing="signature-next"
                                (click)="onNextSignature.emit(item.groupKey)"
                                [disabled]="hiddenRoles().has(item.groupKey)"
                            >
                                <i class="fa-regular fa-chevron-right"></i>
                            </button>
                        </div>
                        }
                        <aix-slide-toggle
                            data-testing="signature-toggle"
                            [initialValue]="!hiddenRoles().has(item.groupKey)"
                            (valueChanges)="onToggleRole.emit(item.groupKey)"
                        ></aix-slide-toggle>
                    </div>
                    }
                </div>
                }
            </div>
            } @if (requiredDocuments?.length) {
            <h5 class="ph-unmask">Required Forms</h5>
            }
            <aix-document-list
                [documentsToDisplay]="requiredDocuments"
                [currentDocument]="documentViewer.currentDocument"
                (clickDownload)="downloadDocument($event)"
            >
            </aix-document-list>
            @if (supplementalFiles?.length) {
            <h5 class="u-mt24 ph-unmask">Supporting Documents</h5>
            }
            <aix-document-list
                [documentsToDisplay]="supplementalFiles"
                [currentDocument]="documentViewer.currentDocument"
                [offset]="requiredDocuments.length"
                (clickDownload)="downloadDocument($event)"
            >
            </aix-document-list>

            } @if (tab === 'Comments') {
            <aix-order-form-comments
                [canAddComments]="(
                    documentViewer.action === 'approve' ||
                    documentViewer.action === 'sign' ||
                    documentViewer.action === 'wetSign') &&
                    documentViewer.hasPermission"
                [canReply]="documentViewer.action === 'resolve' && documentViewer.hasPermission"
                [orderId]="(storeFacade.orderSuccess$ | async)?.id"
                [selectedFormId]="documentViewer.currentFile?.formId"
                [currentDocument]="documentViewer.currentFile!"
                [documentName]="documentViewer.currentFile?.screenName"
                [comments]="(storeFacade.orderFormCommentsSuccess$ | async) | orderFormCommentsFilter:false:true:filesToDisplayIds"
                [mode]="commentsMode"
            >
            </aix-order-form-comments>
            }
        </div>
        }
    </section>
    }
</div>
